export const TWNEL = 'twnel';
export const CUSTOMER = 'customer';

export const TWNEL_LABEL = 'Twnel';
export const CUSTOMER_LABEL = 'Customer';

const storagesDescription = {
  twnel: {
    name: TWNEL,
    label: TWNEL_LABEL,
    editable: true,
    additionable: false,
  },
  customer: {
    name: CUSTOMER,
    label: CUSTOMER_LABEL,
    editable: true,
    additionable: true,
  },
};

export default storagesDescription;
